export const myLeaveTranslationsHu = {
  MY_LEAVE_USER_REQUEST_PAGE_TITLE: "Elbírálandó kérelem adatai",
  MY_LEAVE_MY_LEAVE_REQUESTS_PAGE_TITLE: "Szabadság adataim és kérelmeim",
  MY_LEAVE_HANDLE_LEAVE_REQUESTS_PAGE_TITLE: "Elbírálandó kérelmek adatai",
  MY_LEAVE_NEW_LEAVE: "Új szabadság",
  MY_LEAVE_ASSIGNER_GUIDE: "MyLeave kiíró kézikönyv",
  MY_LEAVE_SAVE_FAILED: "A mentés sikertelen volt.",
  MY_LEAVE_SAVE_SUCCEEDED: "A mentés sikeresen megtörtént.",
  MY_LEAVE_LEAVE_ASSIGN: "Szabadság kiírás",
  MY_LEAVE_SUCCESSFULLY_SAVED: "Az adat(ok) sikeresen elmentve!",
  MY_LEAVE_EXPIRED_CONTRACT_ERROR: "A kérelem kezdete vagy kérelem vége dátuma túlnyúlik a határozott szerződés vége dátumánál!",
  MY_LEAVE_NEXT_YEAR_BLOCKED_ERROR: "A következő évre átnyúló, illetve következő évi szabadság kérelmezése nem engedélyezett!",
  MY_LEAVE_INVALID_YEAR_ERROR: "A szabadság megállapítás nem lehetséges múltbeli évre!",
  MY_LEAVE_REQUEST_HAS_BEEN_WITHDRAWN: "A kérelmet időközben visszavonták",
  MY_LEAVE_ENABLE_LEAVE_REQUESTS: "Dolgozói kérelmek",
  MY_LEAVE_GRANT_LEAVE_TYPES: "Szabadság típusok engedélyezése",
  MY_LEAVE_ABBREVIATED_WORKDAYS: "M.nap",
  MY_LEAVE_ABSENCE_WORK: "Távoli munkavégzés",
  MY_LEAVE_COUNT_OF_WORKDAYS: "Munkanapok száma",
  MY_LEAVE_FULFILLED_ABSENCE: "Kivett távoli munkavégzés",
  MY_LEAVE_LEAVE_AND_ABSENCE_REQUESTS: "Szabadság és távoli munkavégzés kérelmek",
  MY_LEAVE_MY_FULFILLED_LEAVES_AND_ABSENCES: "Kivett szabadságaim és távoli munkavégzéseim",
  MY_LEAVE_REQUESTS: "Kérelmeim",
  MY_LEAVE_MY_LEAVES_AND_ABSENCES: "Szabadság és távoli munkavégzés kérelmeim",
  MY_LEAVE_SHOW_OTHER_ABSENCES: "Távoli munkavégzések mutatása",
  MY_LEAVE_LEAVE_START: "Kérelem kezdete",
  MY_LEAVE_LEAVE_END: "Kérelem vége",
  MY_LEAVE_LEAVE_REQUESTS_HANDLE: "Kérelmek lezárása",
  MY_LEAVE_RECORDED_IN_JDOLBER: "JDolBerben rögzítve",
  MY_LEAVE_COVERAGE_ERROR: "Erre az időszakra már adott be kérelmet!",
  MY_LEAVE_COVERAGE_ERROR_HOME_OFFICE: "Erre az időszakra már adott be Home Office kérelmet!",
  MY_LEAVE_COVERAGE_ERROR_LEAVE: "Erre az időszakra már adott be szabadság kérelmet!",
  MY_LEAVE_OVERLAP_ERROR: "A szabadság ütközik egy távolléttel!",
  MY_LEAVE_WORKDAYS_ERROR: "A munkanapok száma nem lehet 0!",
  MY_LEAVE_APPROVE_LEAVE_REQUEST_SUCCEEDED: "Az elfogadás sikeresen megtörtént!",
  MY_LEAVE_APPROVE_LEAVE_REQUEST_FAILED: "Az elfogadás sikertelen volt!",
  MY_LEAVE_REJECT_LEAVE_REQUEST_SUCCEEDED: "Az elutasítás sikeresen megtörtént!",
  MY_LEAVE_REJECT_LEAVE_REQUEST_FAILED: "Az elutasítás sikertelen volt!",
  MY_LEAVE_SUBSEQUENT_REQUESTS: "Visszamenőleges kérelmek",
  MY_LEAVE_PAYROLL_EMAIL_INFO_TEXT:
    "Elbíráló az aktuális hónapnál maximum egy hónappal visszamenőleg tudja a kérelmeket elfogadni. Az ennél régebbi nyitott kérelmeket már csak a MyLeave Admin jogosultsággal rendelkező felhasználó tudja elfogadni ill. elutasítani. Ezen kérelmek feldolgozása esetén tájékoztatni kell a bérszámfejtést a fent megadott email címen.",
  MY_LEAVE_PAYROLL_EMAIL_ADDRESS: "Bérszámfejtő email cím",
  MY_LEAVE_LEAVES_AND_REMOTE_WORKS: "Szabadságok és távoli munkavégzések",
  MY_LEAVE_REVOKE_LEAVE_REQUEST: "Szabadság kérelmem visszavonása",
  MY_LEAVE_REVOKE_REMOTE_WORK_REQUEST: "Távoli munkavégzés kérelem visszavonása",
  MY_LEAVE_REJECT_REQUEST: "Szabadság elutasítása",
  MY_LEAVE_REJECT_REMOTE_WORK_REQUEST: "Távoli munkavégzés kérelem elutasítása",
  MY_LEAVE_REJECT_LEAVE_REQUEST_TEXT: "Elutasítás esetén üzenetet kell írni a tételhez!",
  MY_LEAVE_ADMINISTRATIVE_EMAIL: "Adminisztrációs email",
  MY_LEAVE_ADMINISTRATIVE_EMAIL_INFO_TEXT:
    "Minden szabadságkérelmezéssel (elfogadással illetve elutasítással) kapcsolatos email másolatát elküldi a rendszer a fent megadott Adminisztrációs email címre. Ezzel a megoldással kiváltható a papír-alapú szabadságos tömb vezetése.",
  MY_LEAVE_MORE_DAYS_ERROR: "A kérelmezett napok száma meghaladja a rendelkezésre álló napok számát!",
  MY_LEAVE_EFFECTIVE_WORK_DAY: "Beosztás szerinti munkanapok száma:",
  MY_LEAVE_USER_GUIDE: "MyLeave felhasználói kézikönyv",
  MY_LEAVE_ADMIN_GUIDE: "MyLeave adminisztrátori kézikönyv",
  MY_LEAVE_EXAMINER_GUIDE: "MyLeave elbírálói kézikönyv",
  MY_LEAVE_VIEWER_GUIDE: "MyLeave megtekintői kézikönyv",
  MY_LEAVE_EFFECTIVE_WORK_DAY_INFO:
    "Amennyiben a kérelmezett szabadság olyan napra esik, ahol a munkaszerződésben szereplő napi munkaórák száma eltér a beosztás szerinti munkaórák számától, a szabadság napok száma a beosztás szerinti munkaórák alapján lesz megállapítva.",
  MY_LEAVE_DAYS: "Napok",
  MY_LEAVE_CONTRACT_WORKDAYS: "Szerződés szerinti munkanap",
  MY_LEAVE_EFFECTIVE_WORKDAYS: "Beosztás szerinti munkanap",
  MY_LEAVE_ENABLE_LEAVE_REQUESTS_INFO: "A dolgozó indíthat szabadsággal vagy távoli munkavégzéssel kapcsolatosan kérelmet.",
  MY_LEAVE_SEPARATE_EMAIL_COMPANY: "Cégenként külön email",
  MY_LEAVE_EXAMINER_CONTROL_PANEL: "Szabadságok áttekintése",
  MY_LEAVE_FULFILLED_BASE_LEAVE: "Kivett szabadság",
  MY_LEAVE_EXAMINERS_CONTROL_PANEL: "Elbírálói nézet",
  MY_LEAVE_VIEWERS_CONTROL_PANEL: "Megtekintői nézet",
  MY_LEAVE_ASSIGNER_CONTROL_PANEL: "Kiíró nézet",
  MY_LEAVE_NO_LEAVE: "Nincs megállapított szabadság",
  MY_LEAVE_CANCELLED_IN_JDOLBER: "JDolBerben sztornózva",
  MY_LEAVE_REQUESTABLE: "Kivehető",
  MY_LEAVE_FULFILLED: "Kivett",
  MY_LEAVE_NEW_REQUEST: "Új kérelem",
  MY_LEAVE_NEW_LEAVE_BASE: "Szabadság",
  MY_LEAVE_COVID_PLUS_10: "CovidPlusz10 szabadság",
  MY_LEAVE_LEAVE_STUDY: "Tanulmányi szabadság",
  MY_LEAVE_LEAVE_EMERGENCY: "Veszélyhelyzeti szabadság",
  MY_LEAVE_LEAVE_ESZJTV: "ESZJTV szabadság",
  MY_LEAVE_LEAVE_SUMMARY: "Szabadság összesítés",
  MY_LEAVE_LEAVE_DETAILS: "Szabadság részletek",
  MY_LEAVE_MY_PREVIOUS_LEAVES: "Korábbi szabadságaim és távoli munkavégzéseim",
  MY_LEAVE_Q: "COVID 327/2021. K.r. +10 nap",
  MY_LEAVE_A: "Apanap munkaidő kedvezmény",
  MY_LEAVE_B: "129.§ (2a) - Tartós távollét miatt akadályoztatott",
  MY_LEAVE_C: "289.§ (4) - Kismama szabadság",
  MY_LEAVE_D: "ESZJTV 19.§ (6) - 2020.12.31-i napok",
  MY_LEAVE_E: "Előző évről maradt",
  MY_LEAVE_F: "Fizetett távollét",
  MY_LEAVE_G: "Gyermek után",
  MY_LEAVE_H: "Első házasságkötés p.sz.",
  MY_LEAVE_I: "Kiállítás, konferencia, oktatás",
  MY_LEAVE_J: "Munkavégzés külső helyszínen",
  MY_LEAVE_K: "Kivizsgálás - MT.55.§",
  MY_LEAVE_L: "Állásidő - MT.146.§(1)",
  MY_LEAVE_M: "Munkavég.alóli ment. - Mt.70.§(2)",
  MY_LEAVE_N: "Szülői szabadság",
  MY_LEAVE_O: "Home Office - ad hoc jellegű otthoni munkavégzés",
  MY_LEAVE_P: "Munkavég.alóli ment. - Mt.55.§(1) j.",
  MY_LEAVE_R: "Rendkívüli",
  MY_LEAVE_S: "Szabadság",
  MY_LEAVE_T: "Tanulmányi szabadság",
  MY_LEAVE_U: "Nagyszülőt megillető p.sz.",
  MY_LEAVE_V: "Veszélyhelyzeti",
  MY_LEAVE_W: "Szakmai rendezvényen való részvétel (DE)",
  MY_LEAVE_X: "Kötelező továbbképzés (DE)",
  MY_LEAVE_Y: "Egyéb szakmai rendezvény (DE)",
  MY_LEAVE_Z: "Szakvizsgára való felkészülés (DE)",
  MY_LEAVE_6: "Gondozói szabadság",
  MY_LEAVE_7: "Kamarai szabadság",
  MY_LEAVE_APPROVED: "Elfogadva",
  MY_LEAVE_RECORDED: "Rögzítve",
  MY_LEAVE_ASSIGNED: "Kiírva",
  MY_LEAVE_CANCELLED: "Sztornózva",
  MY_LEAVE_REQUESTED: "Kérelmezve",
  MY_LEAVE_REJECTED: "Elutasítva",
  MY_LEAVE_INPROGRESS: "Folyamatban",
  MY_LEAVE_BASELEAVEDAYS: "Alapszabadság",
  MY_LEAVE_ONAGE: "Életkor után",
  MY_LEAVE_ONCOUNTOFCHILDREN: "Gyermekek száma után",
  MY_LEAVE_ONSTUDY: "Tanulmányi",
  MY_LEAVE_ONPREVIOUSYEAR: "Előző évről áthozott",
  MY_LEAVE_ONCOVIDPLUS10: "CovidPlusz10",
  MY_LEAVE_ONEXPOSEDTORADIATIONSTATE: "Ionizáló sugárzás után",
  MY_LEAVE_ONDOUBLERISKSTATE: "Kettős kockázati szabadság",
  MY_LEAVE_ONBLINDNESSSATE: "Egészségkárosodás után",
  MY_LEAVE_ONJOBCLASS: "Munkakör után",
  MY_LEAVE_ONJOBGRADE: "Besorolás után",
  MY_LEAVE_ONMANAGERSTATE: "Vezetői beosztás után",
  MY_LEAVE_ONPENSIONERSTATE: "Nyugdíjas állapot után",
  MY_LEAVE_ONTRAINERSTATE: "Oktatói beosztás után",
  MY_LEAVE_ONYOUNGAGE: "Fiatal kor után",
  MY_LEAVE_OTHER: "Egyéb",
  MY_LEAVE_ONESZJTV19: "ESZJTV 19.§ után",
  MY_LEAVE_ONJOBYEARS: "Munkában töltött évek után",
  MY_LEAVE_ONPREVIOUSYEARBASELEAVES: "Előző évről maradt alapszabadság (03.31-ig)",
  MY_LEAVE_ONAGE50YEARS: "50. életév pótszabadság",
  MY_LEAVE_ONPREVIOUSYEARADDITIONALLEAVES: "Előző évről maradt pótszabadság (06.30-ig)",
  MY_LEAVE_ONEMERGENCY: "Veszélyhelyzeti szabadság - 2024.12.31",
  MY_LEAVE_NO_PERMISSION_FOR_ROLE_MESSAGE: "Önnek nincs {{role}} jogosultsága a MyLeave modulhoz",
  MY_LEAVE_NO_PERMISSION_FOR_ROLE: "Nincs jogosultsága ehhez a művelethez",
  MY_LEAVE_NO_PERMISSION_FOR_CONTRACT: "Nincs jogosultsága ehhez a dolgozóhoz",
  MY_LEAVE_ROLE_EXAMINER: "elbíráló",
  MY_LEAVE_ROLE_VIEWER: "megtekintő",
  MY_LEAVE_ROLE_ASSIGNER: "kiíró",
  MY_LEAVE_PAST: "Múlt",
  MY_LEAVE_CURRENT: "Aktuális",
  MY_LEAVE_FUTURE: "Jövőbeni",
  MY_LEAVE_ENABLE_WEEKLY_REPEAT: "Heti ismétlődés engedélyezése",
  MY_LEAVE_SELECT_WEEKDAYS: "Válassza ki a nap(okat):",
  MY_LEAVE_SELECT_AT_LEAST_ONE_DAY: "Legalább egy napot ki kell választani!",
  MY_LEAVE_REPEATED_START_DATE: "Ismétlődés kezdete",
  MY_LEAVE_REPEATED_END_DATE: "Ismétlődés vége",
  MY_LEAVE_REPEATED_HO_SAVE_SUCCEEDED: "{{count}} HomeOffice nap sikeresen létrehozva",
  MY_LEAVE_MONTH_SPLIT_INFO: "Figyelem: A kérelem több hónapon átnyúlik. Minden hónapra külön szabadság tétel fog létrejönni.",
};
